import React from "react";
import styled from "styled-components";
import viewDetailsIcon from "../../../../../images/icon-ellipsis.svg";

const Container = styled.div`
    display: flex;
    flex-grow: 0;
    flex-shrink: 0;
    width: 46px;
    align-items: center;
    justify-content: center;
`;

export const MoreDetailsHeader = ({ideaManagementBlocked}) => {
    if (ideaManagementBlocked) {
        return null;
    }
    return (
        <Container>
            <span>More</span>
        </Container>
    );
};

const ButtonContainer = styled(Container)`
    height: 44px;
    width: 43px;
    border: solid 1px rgba(159,167,178,0.32);
    background-color: #e7e6e5;
`;

const ViewDetailsIcon = styled.img`
    width: 28px;
`;

export const MoreDetailsButton = ({onClick}) => (
    <ButtonContainer className="t-more-details-button"
                     onClick={(e) => {
                         onClick();
                         e.stopPropagation();
                     }}>
        <ViewDetailsIcon src={viewDetailsIcon} alt="More details" />
    </ButtonContainer>
);
